import React, { useEffect, } from "react";
import "../../global.css";
import "./styles.css";
import PropertyComposition from "../../components/PropertyComposition";
import { propertyTypeSections } from "../../components/PropertyComposition/constants";
import { Form } from "antd";

const StepTwo = ({ setStep, tipo, propertyComposition, handlePropertyComposition }) => {

  const [form] = Form.useForm();
  useEffect(() => {
    form.setFieldsValue(propertyComposition);
  }, [propertyComposition]);

  const handleSubmit = (values) => {
    handlePropertyComposition(values);
    setStep(3);
  }

  const selectedFields = propertyTypeSections.find(x => x.propertyType == tipo)
    ?.sections || propertyTypeSections[0].sections;
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'hidden',
      overflowY: 'scroll',
      padding: '1rem',
    }} >
      <PropertyComposition
        selectedFields={selectedFields}
        form={form}
        handleSubmit={handleSubmit}
        propertyTypeId={Number(tipo)}
      />
      <div className="container-next min">
        <button className="btBack" onClick={() => setStep(1)}>Voltar</button>
        <button onClick={() => form.submit()}>Avançar</button>
      </div>

    </div>
  );
};

export default StepTwo;
